<template>
  <div class="protected-title d-flex justify-content-center">
  	<div class="back" @click="back" v-if="iconBack">
  		<i class="fa fa-angle-left"></i>
  	</div>
    <span>{{ $route.meta.title || '' }}</span>
    <div class="share" v-if="share" @click="shareBtn"></div>	
  </div>
</template>
<script>
	export default{
		props:["share","iconBack"],
		methods : {
			back () {
				history.go(-1)
			},
			shareBtn () {
				this.commonShare(this.share.shareURL,this.share.shareTitle,this.share.shareContent,this.share.localLink)
			}
		},
		mounted () {
			
		}
	}
</script>
<style lang="scss" scoped>
.protected-title{
	/*font-weight: bold;*/
 	font-size: .48rem;
 	line-height: 1.2rem;
 	padding: .15rem 0;
 	.back{
 		width:1rem;
 		line-height:1.3rem;
 		font-size:.8rem;
 		text-align: center;
 		position: absolute;
 		left:0;
 		top:0;
 		color:#999999;
 	}
 	.share{
 		position: absolute;
 		right:0;
 		top:0;
 		width:1.2rem;
 		height:1.2rem;
 		background: url("../../../assets/imgs/icons/wx_share_img.png") no-repeat 50% 45%;
 		background-size:50% 50%;
 	}
}
</style>
 
